import { useContext, useEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { useLocation } from 'react-router-dom';

export default function RouteWrapper({
  component: Component,
  isPrivate,
  ...rest
}) {
  const { signed, loading, user, verificaToken, periodoInscricoesAtivo, loadingPeriodo } = useContext(AuthContext);
  const location = useLocation();

  useEffect(() => {
    if (!signed) {
      const userTemp = JSON.parse(localStorage.getItem("user"));
      if (userTemp != null) {
        verificaToken(userTemp);
      }
    }
  }, [signed, verificaToken]);

  if (loading) {
    return (
      <div> Carregando..... </div>
    )
  }

  if (loadingPeriodo && location.pathname === '/') {
    return (
      <div> Verificando período de inscrição... </div>
    )
  }

  if (!signed && isPrivate) {
    return <Redirect to="/login" />
  }

  // if (location.pathname === '/' && !periodoInscricoesAtivo && !loadingPeriodo) {
  //     console.log("Período de inscrição inativo, redirecionando para /login"); 
  //     return <Redirect to="/login" />;
  // }

  if (signed && !isPrivate) {

    const hasUserRole = user.perfilUser?.some(role =>
      role.startsWith("user-")
    );

    if (hasUserRole) {
      localStorage.setItem("user", JSON.stringify(user));
      const route = localStorage.getItem("route") || "/admin";
      return <Redirect to={route} />;
    }

    return <Redirect to="/login" />;
  }


  return (
    <Route
      {...rest}
      render={props => (
        <Component {...props} />
      )}
    />
  )
}